import React, {FC, useEffect, useState} from "react";
import ButtonCircle from "components/Button/ButtonCircle";
import rightImg from "images/subscribe.svg";
import NcImage from "components/NcImage/NcImage";
import Badge from "components/Badge/Badge";
import Input from "components/Input/Input";
import {addDoc, collection, doc, getDoc, getDocs, query, serverTimestamp, setDoc, where} from "firebase/firestore";
import {auth, db} from "../../configs/firebase-config";
import {displayToast, toastType} from "../../global/Functions";

export interface SectionSubscribe2Props {
  className?: string;
}

const SectionSubscribe2: FC<SectionSubscribe2Props> = ({ className = "" }) => {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);

  const newsletterCollectionRef = collection(db, "newsletter");

  const processNewsletter = async (e : any) => {
    e.preventDefault();

    try{
      await setDoc(doc(newsletterCollectionRef, email), {
        email,
        time: serverTimestamp()
      });
      displayToast("Thanks for Subscribing", toastType.info);
    } catch (error) {
      displayToast("Something went wrong", toastType.error);
    }


    e.target.reset();
  };

  useEffect(() => {
    if (!auth.currentUser) return;

    getDoc(doc(newsletterCollectionRef, `${auth.currentUser.email}`)).then((result) => {
      setIsSubscribed(result.exists());
    });
  },[])

  return (
    <div
      className={`nc-SectionSubscribe2 relative flex flex-col lg:flex-row items-center ${className}`}
      data-nc-id="SectionSubscribe2"
    >
      <div className="flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
        <h2 className="font-semibold text-4xl">Join Our Newsletter 🔔</h2>
        <ul className="space-y-5 mt-10">
          <li className="flex items-center space-x-4">
            <Badge color="indigo" name="⭐" />
            <span className="font-medium text-neutral-700 dark:text-neutral-300">
            Get discounted membership to CryptoVerse
          </span>
          </li>
          <li className="flex items-center space-x-4">
            <Badge color="indigo" name="⭐" />
            <span className="font-medium text-neutral-700 dark:text-neutral-300">
            Get premium insights from our specialist team
          </span>
          </li>
        </ul>
        {isSubscribed ?
          <div className="mt-8 font-medium text-xl text-neutral-700 dark:text-neutral-300">Stay tuned!</div>
          :
          <form className="mt-10 relative max-w-sm" onSubmit={processNewsletter}>
            <Input
              required
              aria-required
              placeholder="Enter your email"
              type="email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <ButtonCircle
              type="submit"
              className="absolute transform top-1/2 -translate-y-1/2 right-1"
            >
              <i className="las la-arrow-right text-xl"></i>
            </ButtonCircle>
          </form>
        }
      </div>
      <div className="flex-grow">
        <NcImage src={rightImg} />
      </div>
    </div>
  );
};

export default SectionSubscribe2;
